/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 13:39:17
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2022-02-09 13:38:31
 */
import configData from "../config/config";
import sys from "@/store/index";
import operManage from "./oper-manage";
import financeManage from "./finance-manage";
import pileManage from "./pile-manage";
import memberManage from "./member-manage";
import interflowManage from "./interflow-manage";
import operators from "./operators";
import deProduct from "./de-product";
import operMonitor from "./oper-monitor";
import home from "./home";
import sysManage from "./sys-manage";
import operationAnalysis from "./operation-analysis";
import alarm from "./alarm";
import agentMerchant from "./agent-merchant";
import mchCenter from "./mch-center"; //
import i18n from "@/config/i18n";
const allRouter = [
    ...operManage,
    ...home,
    ...financeManage,
    ...pileManage,
    ...memberManage,
    ...interflowManage,
    ...operators,
    ...deProduct,
    ...sysManage,
    // ...operMaintain,
    ...operationAnalysis,
    ...alarm,
    ...operMonitor,
    ...agentMerchant,
    ...mchCenter,
];
/**
 * 把权限单独拿出来拼到路由里面去
 * @param list 路由的权限
 * @returns
 */
const getPower = (list) => {
    const prwerObj = {};
    const config = configData.powerObj;
    list.map((item) => {
        if (config[item.privilegeCode]) {
            prwerObj[config[item.privilegeCode]] = item.checked;
        }
    });
    return prwerObj;
};
const allRouterArray = allRouter; // 剩余路由
/**
 * 根据接口权限，把对应的权限路由组装好返回去
 * @param userRouter 接口的权限，已经处理过，用户拥有权限包括 children 里的，已经重组成一级数组, [{},{},{},{},{}]
 * @returns
 */
const recursionRouter = (userRouter) => {
    const userRoutes = []; // 用户最终的权限路由
    const routerObj = {}; // 所有添加的路由，页面右上角的消息跳转会判断是否有对应的页面用到
    // let index = 0;
    userRouter.forEach((v) => {
        // index++;
        let routerIndex = -1; // 循环相等的数据
        for (const i in allRouterArray) {
            const item = allRouterArray[i];
            if (item.path === v.url) {
                // 把用户权限的数据拿出来
                const data = JSON.parse(JSON.stringify(v));
                let privilegeVoObj = {};
                if (data.privilegeVoList && data.privilegeVoList.length > 0) {
                    privilegeVoObj = getPower(data.privilegeVoList);
                }
                const itemData = addRouterData(item, data, privilegeVoObj, true);
                userRoutes.push(itemData);
                routerObj[item.path] = item.name;
                // 把路由的子菜单路由也添加进列表
                if (item.children && item.children.length > 0) {
                    if (item.path == "/home/index") {
                        // 主页大屏要特别处理
                        if (privilegeVoObj.homeData) {
                            configData.isHomeData = true;
                        }
                    }
                    item.children.map((child) => {
                        const childrenData = addRouterData(child, data, privilegeVoObj, false);
                        if (item.path != "/home/index/home-data") {
                            // 不是主页大屏就直接加
                            userRoutes.push(childrenData);
                            routerObj[item.path] = item.name;
                        }
                        else {
                            if (configData.isHomeData) {
                                // 是主页大屏就有权限再加
                                userRoutes.push(childrenData);
                                routerObj[item.path] = item.name;
                            }
                        }
                    });
                }
                if (configData.otherPageAuto) {
                    // 菜单以外的页面是否有权限
                    const otherPageAuto = configData.otherPageAuto;
                    if (otherPageAuto[item.path]) {
                        sys.commit("SET_OTHERPAGEAUTO", otherPageAuto[item.path]);
                    }
                }
                routerIndex = Number(i);
                break; // 找到并添加上路由后就跳转出去
            }
            // index++;
        }
        if (routerIndex != -1) {
            allRouterArray.splice(routerIndex, 1); // 已经添加过的就删掉，减少循环次数
        }
    });
    configData.autoUrl = routerObj;
    // console.log(index);
    return userRoutes;
};
/**
 * 重新组装一下页面路由 allRouter 对象，要添加一些参数和去掉 children，不去掉会变成它的子路由，需要把 children 里的路由做成 一级路由
 * @param item 路由对象
 * @param userRouterData  用户接口权限数据
 * @param privilegeVoObj  用户的权限数据
 * @param isMain  是否是主路由
 * @returns 新的路由对象
 */
const addRouterData = (item, userRouterData, privilegeVoObj, isMain) => {
    // 把用户权限的数据和权限数据并入路由的 meta 数据里
    if (item.meta) {
        item.meta.menuData = userRouterData;
        item.meta.privilegeVoObj = privilegeVoObj;
    }
    else {
        item.meta = {
            privilegeVoObj: privilegeVoObj,
            menuData: userRouterData,
        };
    }
    // 把主路由的名称换成用户权限里的菜单多语言名称，并且标名是主路由 mainPage
    const language = sessionStorage.getItem("language") || "";
    if (isMain) {
        const name = language == "en" && userRouterData.englishName != undefined
            ? userRouterData.englishName
            : userRouterData.moduleName;
        item.name = name; //data.moduleName;
        item.meta.mainPage = true;
    }
    else {
        if (item.meta && item.meta.nameKey) {
            const key = "childMenuTitle." + item.meta.nameKey;
            item.name = i18n.t(key);
        }
    }
    const itemData = {};
    // console.log(item);
    // 去掉 allRouter 路由上的 childrem， children 会添加进路由的第一级
    for (const i in item) {
        if (i != "children") {
            itemData[i] = item[i];
        }
    }
    return itemData;
};
export default recursionRouter;
